import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Message, Icon } from 'semantic-ui-react';
import { CustomerAccountInfo } from '@modules/auth/components/types/customer-account';
import { isTrialUser } from '@modules/auth/components/constants/accounts';

import { StoreState } from '@src/meta/types/store';
import TargetBlankLink from '@src/components/common/TargetBlankLink';
import InfoMessage from '@modules/common/components/banners/InfoMessage';
import config from '@config/config';

type Props = {
  shAccount?: CustomerAccountInfo;
};

const NoRBanner = ({ shAccount }: Props) => {
  const [isClosed, setIsClosed] = useState(() => {
    return localStorage.getItem('norBannerClosed') === 'true';
  });

  if (config.displayTopPageBanners || isClosed) {
    return null;
  }

  const onClose = () => {
    localStorage.setItem('norBannerClosed', 'true');
    setIsClosed(true);
  };

  return (
    <InfoMessage withMargin icon onDismiss={onClose} style={{ width: 'auto' }}>
      <Icon name="info" />
      <Message.Content>
        {shAccount === undefined || isTrialUser(shAccount.type.id) ? (
          <NoRTrialMessage />
        ) : (
          <NoRSuscribedMessage />
        )}
      </Message.Content>
    </InfoMessage>
  );
};

const NoRTrialMessage = () => (
  <>
    <b>NoR Sponsored Accounts and Access to Commercial Datasets</b>
    <p>
      If you're conducting research, you might benefit from having access to high-resolution
      commercial satellite datasets, such as SPOT, Pleiades or PlanetScope.
      <br />
      To apply for ESA sponsored account and access to datasets for research purposes, follow our{' '}
      <TargetBlankLink href="https://www.sentinel-hub.com/Network-of-Resources/">
        step-by-step guide!
      </TargetBlankLink>
    </p>
  </>
);

const NoRSuscribedMessage = () => (
  <>
    <b>NoR Sponsored Access to Commercial Datasets</b>
    <p>
      If you're conducting research, you might benefit from having access to high-resolution
      commercial satellite datasets, such as SPOT, Pleiades or PlanetScope.
      <br />
      To apply for ESA sponsored access to datasets for research purposes, follow our{' '}
      <TargetBlankLink href="https://www.sentinel-hub.com/Network-of-Resources/">
        step-by-step guide!
      </TargetBlankLink>
    </p>
  </>
);

const mapStateToProps = (state: StoreState) => ({
  shAccount: state.account.account,
});

export default connect(mapStateToProps)(NoRBanner);
